export default "__VITE_PUBLIC_ASSET__b37ae61a__"